import { render, staticRenderFns } from "./ViewOrderDetailsModal.vue?vue&type=template&id=0205dd9e&"
import script from "./ViewOrderDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ViewOrderDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports